import VueStore from "../../store/VueStore";
import { createAPIGatewayUrl } from "./create_url";
import { createAPIGatewayUrlV2 } from "./create_url_v2";

export class RequestParamsController {
  public static create(method: string, path: string, data: any) {
    return {
      method,
      url: createAPIGatewayUrl(path),
      data,
      headers: {
        Authorization: VueStore.state.token,
      },
    };
  }
  public static create_v2(method: string, path: string, data: any) {
    return {
      method,
      url: createAPIGatewayUrlV2(path),
      data,
      headers: {
        Authorization: VueStore.state.token,
      },
    };
  }
}
